import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector} from 'react-redux'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Button, TextField, InputLabel } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Alert from '@material-ui/lab/Alert';
import { Table, TableHead, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { getWarehouseInfo, getParcelReturnReference, addParcelReturn } from '../../actions/parcelReturnActions';

const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.background.paper,
      //width: 500,
    },
  }));

export default function ParcelReturn(props) {

    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();
  
    const warehouseList = useSelector(state => state.parcelReturn.warehouseList) ;
    const parcelBatchNo = useSelector(state => state.parcelReturn.parcelBatchNo);
    const parcelTotal = useSelector(state => state.parcelReturn.parcelTotal);
    const parcelScanStartNo = useSelector(state => state.parcelReturn.parcelScanStartNo) || 0;
    const addParcelRtnStatus = useSelector(state => state.parcelReturn.addParcelRtnStatus);
    const addParcelRtnRetMsg = useSelector(state => state.parcelReturn.addParcelRtnRetMsg);
    const scanResult = useSelector(state => state.parcelReturn.scanResult);
      
    const [parcelRtnNo, setParcelRtnNo] = useState();
    const [warehouse, setWarehouse] = useState();
    const [currentScanNo, setCurrentScanNo] = useState();
    const [successScanNum,setSuccessScanNum] = useState(0);
    const [failScanNum,setFailScanNum] = useState(0);

      
    const [scanList,setScanList] = useState([]);

    /**
     * init: 
     * 1. get the warehouse info  
     * 2. get the specific warehouse that deal with the return process 
     *    .get from the local storage if it's exist, could be chaged by the user
     *    .if not exist user should choose the warehouse manually
     */
    useEffect(() => {
        dispatch(getWarehouseInfo());
        
        // 读取 localStorage 中 Json 格式数据
        var value = parseInt(localStorage.getItem("warehouse"));    // 取回 value 变量
        if (value !== NaN) {
            setWarehouse(value);
        } 

    }, []);


    /**
     * get the parcel return reference such as batchNo, parcel total number and scan start no according to the waregouse
     */
    useEffect(() => {        
        if (warehouse !== undefined && warehouse !== null && parseInt(warehouse) !== NaN) {
            dispatch(getParcelReturnReference(warehouse));
        } else if (warehouseList !== null && warehouseList.length > 0) {
            setWarehouse(warehouseList[0].id);
        }
    }, [warehouse]);    
    
    /**
     * get the parcel return reference such as batchNo, parcel total number and scan start no according to the waregouse
     */
    useEffect(() => {        
        if (typeof(scanResult.tnos) !== undefined && scanResult.tnos !== null && scanResult.tnos !== "") {
            let list = scanList;
            
            list.forEach(function(value,index,array) {
                if (addParcelRtnStatus === "SUCCESS" && array[index]['parcelRtnNo'] === scanResult.tnos) {
                    setSuccessScanNum(successScanNum + 1);
                    if (array[index]['status'].indexOf("FAIL") >= 0) {          //in rescan case
                        setFailScanNum(failScanNum - 1);
                    } 
                    array[index]['status'] = addParcelRtnStatus + " " + addParcelRtnRetMsg;
                } else if ((addParcelRtnStatus === "FAIL" && array[index]['parcelRtnNo'] === scanResult.tnos)) {
                    if (array[index]['status'] === "") {          //init scan case
                        setFailScanNum(failScanNum + 1);
                    } 
                    array[index]['status'] = addParcelRtnStatus + " " + addParcelRtnRetMsg;
                }

            })               
            setScanList(list);
        }

    }, [addParcelRtnStatus]);

      
  return (
    <div className={classes.root} >
        <div style={{display: 'flex', flexDirection: 'row', padding: 16}}>
            <Chip color="secondary" label="Parcel Return" />
        </div>
        <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}}>
            <TextField
                id="parcelRtnNo"
                label="parcelRtnNo"
                InputLabelProps={{ shrink: true }}
                type="string"
                variant="outlined"
                value={parcelRtnNo}
                onKeyUp={(e)=>handleKeyUp(e)} 
                style={{paddingLeft: 16, width: 350,paddingRight: 16}}
            />            
            <TextField 
                id="warehouse"
                select
                label="warehouse"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={warehouse} 
                onChange={(e)=>{handleWarehouseChange(e)}}
                SelectProps={{
                    native: true,
                }}      
                style={{width: 350, paddingRight: 16}}
            >
            {warehouseList.map((item) => (
                <option key={item.name} value={item.id}>
                {item.name}
                </option>
            ))}
            </TextField>     
            <InputLabel
                severity="info" 
                style={{width: 460,paddingRight: 50}}
            >
                当前批次为: {parcelBatchNo}，共有: {parcelTotal}单，扫描序号从: {parcelScanStartNo}开始
            </InputLabel>
                
            <Alert 
                severity="error" 
                style={{width: 350,paddingRight: 16}}
            >
                一共扫描: {successScanNum + failScanNum}，成功扫描件数: {successScanNum}，失败扫描件数: {failScanNum}
            </Alert>
            {
                (failScanNum > 0)
                ?
                <Button 
                    variant="contained"
                    color="secondary" 
                    onClick={handleReScan}  
                    style={{marginLeft: 100,width: 100,paddingRight: 16}}
                >
                    ReSubmit
                </Button>
                :
                null
            }
        </div>
        <div style={{fontSize: 40, textAlign: 'center'}}>
            仓库位置编号：{currentScanNo}
        </div>
        
        <div>
            <TableContainer component={Paper} style = {{paddingTop: 16}}>
                <Table className={classes.table} >
                <TableHead>
                    <TableRow>
                    <TableCell align="center">编号</TableCell>
                    <TableCell align="center">Ant Parcel单号</TableCell>
                    <TableCell align="center">状态</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        (scanList !== null && scanList.length > 0) 
                        ?
                        scanList.map((row) => (
                            <TableRow key={row.id} >
                                <TableCell align="center">{row.id}</TableCell>
                                <TableCell align="center">{row.parcelRtnNo}</TableCell>
                                {
                                    (row.status.indexOf("SUCCESS") >= 0) 
                                    ?
                                    <TableCell align="center" style={{color: 'FFFFFF'}}>{row.status}</TableCell>
                                    :
                                    <TableCell align="center" style={{color: 'FF0000'}}>{row.status}</TableCell>
                                }
                            </TableRow>
                        ))
                        :
                        null
                    }
                </TableBody>
                </Table>
            </TableContainer>
        </div>
    </div>
  );

  /**
   * resubmit the failed ones
   */
  function handleReScan() {
      let list = scanList.filter((item)=> item.status.indexOf("FAIL") >= 0 );

      list.map((item)=>{
        dispatch(addParcelReturn(
            {
                warehouse: warehouse, 
                batch_no: parcelBatchNo, 
                tnos: item.parcelRtnNo, 
                add_on: 0,
                local_import: 0,
            }));
      });
  }

  /**
   * post to the backend when the "Enter" key was pressed
   * @param {*} e 
   */
  function handleKeyUp(e) {    
    if(e.keyCode === 13) {
        // get the value and reset the input field
        let parcelRtnNo = e.target.value;
        e.target.value = "";

        //assemble the params which will post to the backend
        let params = {};

        params['warehouse'] = warehouse;
        params['batch_no'] = parcelBatchNo;
        params['tnos'] = parcelRtnNo;

        //API needed , don't know the meaning....
        params['add_on'] = 0;
        params['local_import'] = 0;

        //update the current scan number and the scan list
        let list = new Array();
        setCurrentScanNo(parcelScanStartNo + scanList.length );
        list[0] = {id: parcelScanStartNo + scanList.length , parcelRtnNo: parcelRtnNo, status: ""};
        scanList.forEach(function(value,index,array){
            list[index+1] = array[index];
        });
        setScanList(list);        

        //post
        dispatch(addParcelReturn(params));
    }
  }

  /**
   * save the warehouse value to localstorage when it changes
   * @param {*} e 
   */
  function handleWarehouseChange(e) {
    let warehouse = parseInt(e.target.value);
    
    setWarehouse(warehouse);

    // 存储 localStorage 
    localStorage.setItem("warehouse", warehouse);     

    }

}


